import { openGetQuote as openGetQuoteUrl } from '@/utils/utils'
import { useProductDetail } from '@/views/OfferView/components/hooks/useProductDetail'

export const useGetQuote = () => {
  const { detailInfo } = useProductDetail()

  const openGetQuote = () => {
    openGetQuoteUrl(detailInfo.value?.productImage?.images?.[0])
  }

  return { openGetQuote }
}
